import { QueryHookOptions, useQuery } from '@apollo/react-hooks'
import { CATEGORY_QUERY } from 'apollo'

export const useCategoryQuery = (options: QueryHookOptions<any, any> = {}) => useQuery(CATEGORY_QUERY, options)
